/* eslint-disable */
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { navigateToRoute } from '../../../../redux_store';
import MenuItem from '../../../Shared/Table/widgets/MenuItem';
import { ReactComponent as UsersIcon } from '../../../../assets/icons/users.svg';
import { ReactComponent as EditIcon } from '../../../../assets/icons/edit.svg';
import { checkPermission } from '../../../../helpers/checkPermissions';
import permissions from '../../../../config/permissions';
import CloudUpload from '@material-ui/icons/CloudUpload';
import { ReactComponent as DownloadIcon } from '../../../../assets/icons/file_download_black.svg';
import { ReactComponent as RemoveIcon } from '../../../../assets/icons/remove.svg';
import { ALL_ROUTES } from '../../../../config/routes';


const TableActions = ({
                        row,
                        setAnchorEl,
                        setDownloadAccount,
                        setOpenRemoveDialog,
                        setRemovingAccount,
                      }) => {
  const {
    en: {
      titles,
    },
  } = useSelector((state) => state.i18n);
  const dispatch = useDispatch();
  const {
    metadata: { currentAccountPermissions, currentAccount },
    isDistributionSponsor,
  } = useSelector((state) => state.user);

  const handleItemClick = (route, title, uuid, businessName) => {
    // For user management, add query parameters for pre-selected account
    const isUserManagement = route.path === ALL_ROUTES.user.globalManagement.path;

    let finalPath = route.path;
    let clearBreadcrumbs = false;

    // Add query parameters for user management to pre-select account
    if (isUserManagement && uuid && businessName) {
      const queryParams = new URLSearchParams({
        preselectedAccountUuid: uuid,
        preselectedAccountName: businessName,
      });
      finalPath = route.path + '?' + queryParams.toString();
      clearBreadcrumbs= true;
    }

    const routeConfig = {
      path: finalPath,
      params: {
        currentAccountUuid: currentAccount.uuid,
        accountUuid: uuid,
      },
      title: title,
      clearBreadcrumbs: clearBreadcrumbs,
    };

    dispatch(navigateToRoute({ route: routeConfig }));
  };

  const handleDownloadPracticeOptimizationReportClick = (e, {
    uuid,
    businessName,
  }) => setDownloadAccount({ uuid: uuid, businessName: businessName });

  const handleRemoveItemClick = (e, account) => {
    setOpenRemoveDialog(true);
    setRemovingAccount(account);
  };

  const hasImportPermission = useMemo(
    () => checkPermission(
      currentAccountPermissions,
      permissions.ADMIN_PATIENT_IMPORT,
    ),
    [currentAccountPermissions],
  );

  const actions = [
    {
      key: '1',
      icon: <UsersIcon />,
      onActionClick: (e, { uuid, businessName }) => {
        handleItemClick(ALL_ROUTES.user.globalManagement, titles.users, uuid, businessName);
      },
      children: titles.editUsers,
    },
    {
      key: '2',
      icon: <EditIcon />,
      onActionClick: (e, { uuid }) => {
        handleItemClick(ALL_ROUTES.account.editDS, titles.editAccount, uuid);
      },
      children: titles.editAccount,
    },
    ...hasImportPermission ? [{
      key: '3',
      icon: <CloudUpload style={{ fontSize: 16 }} />,
      onActionClick: (e, { uuid, businessName }) => {
        handleItemClick(ALL_ROUTES.account.patientUpload, titles.patientUpload, uuid, businessName);
      },
      children: titles.patientUpload,
      addDivider: true,
    }, {
      key: '4',
      icon: <CloudUpload style={{ fontSize: 16 }} />,
      onActionClick: (e, { uuid, businessName }) => {
        handleItemClick(ALL_ROUTES.account.insuranceUpload, titles.insuranceUpload, uuid, businessName);
      },
      children: titles.insuranceUpload,
    }, {
      key: '5',
      icon: <CloudUpload style={{ fontSize: 16 }} />,
      onActionClick: (e, { uuid, businessName }) => {
        handleItemClick(ALL_ROUTES.account.providersUpload, titles.providersUpload, uuid, businessName);
      },
      children: titles.providersUpload,
    }, {
      key: '6',
      icon: <CloudUpload style={{ fontSize: 16 }} />,
      onActionClick: (e, { uuid, businessName }) => {
        handleItemClick(ALL_ROUTES.account.claimsUpload, titles.claimsUpload, uuid, businessName);
      },
      children: titles.claimsUpload,
    }] : [],
    ...hasImportPermission ? [{
      key: '7',
      icon: <DownloadIcon />,
      onActionClick: handleDownloadPracticeOptimizationReportClick,
      children: titles.downloadPracticeOptimizationReport,
      addDivider: true,
    }] : [],
    {
      key: '8',
      icon: <RemoveIcon />,
      onActionClick: handleRemoveItemClick,
      children: titles.removeAccount,
      isRemove: true,
      addDivider: true,
    },
  ];

  const children = useMemo(
    () => actions.map((props) => {
      const { children, onActionClick, icon, addDivider, isRemove } = props;
      return <MenuItem
        title={children}
        icon={icon}
        setAnchorEl={setAnchorEl}
        onClick={(e) => onActionClick(e, row.original)}
        hasTopDriver={addDivider}
        isErrorStyle={isRemove}
      />;
    }),
    [row],
  );

  return <>
    {children}
  </>;
};

export default TableActions;
